export default {"src":"/_next/static/media/check-icon.c832ea98.svg","height":13,"width":18,"blurWidth":0,"blurHeight":0};